// tslint:disable:max-line-length
import t from './strings'

const { startDashing, acceptOrders, pickAndDropoff, getPaid } = t

import { AWS_BASE, CLOUDFLARE_DEFAULT_BASE } from '../../../constants'

const URL_BASE = `${CLOUDFLARE_DEFAULT_BASE},width=585/${AWS_BASE}`

export enum SlideItems {
  HowToDash = 'HowToDash',
  Accept = 'Accept',
  PickupDropoff = 'PickupDropoff',
  Earnings = 'Earnings',
}

export type SlideType = {
  url: string
  alt: string
  title: string
  description?: string
}

export const getSlideItem = (item: SlideItems): SlideType => {
  switch (item) {
    case SlideItems.HowToDash:
      return {
        url: `${URL_BASE}/img/dasher/how-to-dash-screenshot-1-dash-now.png`,
        alt: 'HowToDash',
        title: startDashing.title(),
        description: startDashing.description(),
      }
    case SlideItems.Accept:
      return {
        url: `${URL_BASE}/img/dasher/how-to-dash-screenshot-2-accept.png`,
        alt: 'Accept',
        title: acceptOrders.title(),
        description: acceptOrders.description(),
      }
    case SlideItems.PickupDropoff:
      return {
        url: `${URL_BASE}/img/dasher/how-to-dash-screenshot-3-pickup-and-dropoff.png`,
        alt: 'PickupDropff',
        title: pickAndDropoff.title(),
        description: pickAndDropoff.description(),
      }
    case SlideItems.Earnings:
      return {
        url: `${URL_BASE}/img/dasher/how-to-dash-screenshot-4-earnings.png`,
        alt: 'Earnings',
        title: getPaid.title(),
        description: getPaid.description(),
      }
    default:
      return {
        url: '',
        alt: '',
        title: '',
        description: '',
      }
  }
}

export const slideItemList = () => {
  const result: SlideType[] = []

  Object.keys(SlideItems).map(item => {
    const myItem: SlideItems = SlideItems[item] as SlideItems
    result.push(getSlideItem(myItem))
  })

  return result
}
